module.exports = __webpack_public_path__ + "static/media/resume.e84692b5.png";